import type { ChatMessage } from '@/hooks/useConversation'

type Props = { message: ChatMessage; showDate: boolean }

export function MessageBubble({ message, showDate }: Props) {
  return (
    <>
      {showDate && (
        <div className="text-center my-3">
          <span className="text-xs text-muted-foreground bg-muted/50 rounded-full px-3 py-1">
            {formatDateSeparator(message.created_at)}
          </span>
        </div>
      )}
      <div
        className={`flex ${message.is_mine ? 'justify-end' : 'justify-start'} mb-1`}
      >
        <div
          className={`max-w-[75%] rounded-2xl px-3.5 py-2 ${
            message.is_mine
              ? 'bg-primary text-primary-foreground rounded-br-sm'
              : 'bg-muted rounded-bl-sm'
          }`}
        >
          <p className="text-sm whitespace-pre-wrap break-words">
            {message.body}
          </p>
          <p
            className={`text-[10px] mt-0.5 ${
              message.is_mine
                ? 'text-primary-foreground/70'
                : 'text-muted-foreground'
            } text-right`}
          >
            {formatTime(message.created_at)}
          </p>
        </div>
      </div>
    </>
  )
}

function formatDateSeparator(iso: string): string {
  const d = new Date(iso)
  const today = new Date()
  const yesterday = new Date()
  yesterday.setDate(today.getDate() - 1)

  if (d.toDateString() === today.toDateString()) return 'Today'
  if (d.toDateString() === yesterday.toDateString()) return 'Yesterday'
  return d.toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
  })
}

function formatTime(iso: string): string {
  return new Date(iso).toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
  })
}
